const MALE_PRONOUNS = { subject: "He", possessive: "his" };
const FEMALE_PRONOUNS = { subject: "She", possessive: "her" };
const UNSPECIFIED_PRONOUNS = { subject: "He/She", possessive: "his/her" };

const getPronouns = (gender?: string | null) => {
  switch ((gender || "").toUpperCase()) {
    case "MALE":
      return MALE_PRONOUNS;
    case "FEMALE":
      return FEMALE_PRONOUNS;
    default:
      return UNSPECIFIED_PRONOUNS;
  }
};

// Predefined remark templates use "He/She" / "his/her" as placeholders.
// Swap them for the student's actual pronoun so the remark reads naturally.
export const getRemarkWithPronoun = (
  remark: string,
  gender?: string | null,
): string => {
  const { subject, possessive } = getPronouns(gender);

  return remark
    .replace(/He\/She/g, subject)
    .replace(/his\/her/g, possessive);
};
